module.exports = __webpack_public_path__ + "static/media/avatar-frame.7377014a.png";